






































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { onlyNumber } from '@/utils/common'

@Component

export default class ComponentRemuneracaoValidacaoRightNavBar extends Vue {
  fltLoading: boolean = false

  get statusGeracaoRepasse() {
    return this.getStore.selectedStatus
  }

  set statusGeracaoRepasse(value: any) {
    this.getStore.setSelectedStatus(value.key)
  }

  get status() {
    return this.getStore.statusList
  }

  get selectedPrestador() {
    return this.getStore.selectedPrestador
  }

  set selectedPrestador(value) {
    this.getStore.setSelectedPrestador(value)
  }

  get getPrestadoresList() {
    return this.getStore.gerarRepassePrestadores
  }

  get filterLoading() {
    return this.fltLoading
  }

  set filterLoading(value: boolean) {
    this.fltLoading = value
  }

  get getStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get drawer() {
    return this.getStore.filterValidacaoEGeracaoRepasseDrawer
  }

  set drawer(value: boolean) {
    this.getStore.setFilterValidacaoEGeracaoRepasseDrawer(value)
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async search() {
    this.filterLoading = true
    const id = this.getStore.idForLoadValidacaoEGeracaoRepasse
    await this.getStore.getGeracaoDeRepassesItemsVisualizar(id)
    this.getStore.setFilterOn(this.hasAnyFilter())
    this.filterLoading = false
  }

  hasAnyFilter(): boolean {
    return this.getStore.selectedStatus.length > 0 || this.getStore.selectedPrestador !== ''
  }

  async clear() {
    this.getStore.clearFilterValidacaoEGeracaoRepasse()
    this.getStore.setFilterOn(false)
    await this.search()
  }

  async selectStatus(item: any) {
    this.statusGeracaoRepasse = item
  }

  windowHeight: number = 0

  getWindowHeight() {
    const doc: Document = document

    if (doc !== null) {
      this.windowHeight = doc.documentElement.clientHeight
    }
  }

  async init() {
    this.getStore.getConveniosRepasse()
  }

  async mounted() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
    await this.init()
  }

  async updated() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }
}
